import React from "react"
import { Box, Chip, Typography, List, ListItem } from "@mui/joy"
import { Icon } from "../../assets"
import { Tag } from "../Snippet"
import { Anchor } from "../Typography"

const InfoHeaderAudianceLead = ({ item }) => {

	const formatDate = (dateValue) => {
		if (!dateValue) {
			return '-';
		}
		const date = new Date(dateValue);
		if (isNaN(date.getTime())) {
			return '-';
		}
		return date.toISOString().slice(0, 10);
	};

	return (
		<Box
			className="info-header info-header-person"
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				p: 2,
				borderRadius: 'lg',
				bgcolor: 'neutral.softBg'
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
				<Box
					sx={{
						width: 64,
						height: 64,
						borderRadius: '50%',
						bgcolor: 'neutral.softActiveBg',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						fontSize: 'lg',
						fontWeight: 'lg',
						flexShrink: 0,
						mt: '4px'
					}}
				>
					{(item?.firstname?.[0]) || ' '}
				</Box>

				<Box sx={{ flex: 1 }}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
						<Chip color="neutral" variant="soft" startDecorator={<Icon icon="faBuilding" />}>
							{item?.company || '-'}
						</Chip>
						<Chip color="primary" variant="soft">{item?.role || '-'}</Chip>
					</Box>

					<Typography level="h4" sx={{ mb: 0.5 }}>{item?.firstname || '-'} {item?.lastname || '-'}</Typography>

					<List
						orientation="horizontal"
						sx={{ gap: 2, m: 0, mb: 1, alignItems: 'center' }}
					>
						<ListItem sx={{ p: 0 }}>
							<Anchor icon="faEnvelope" iconfamily="fal" href={`mailto:${item?.email || ''}`}>
								{item?.email || '-'}
							</Anchor>
						</ListItem>
						<ListItem sx={{ p: 0 }}>
							<Anchor icon="faPhone" iconfamily="fal" href={`tel:${item?.telephone || ''}`}>
								{item?.telephone || '-'}
							</Anchor>
						</ListItem>
					</List>

					<Box>
						<Typography level="body-sm" sx={{ mb: 0.5 }}>Segmenti</Typography>
						<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
							{item?.segments?.length > 0
								? item.segments.map((seg, i) => <Chip key={i} color="primary" variant="soft">{seg}</Chip>)
								: <Chip color="primary" variant="soft">-</Chip>
							}
						</Box>
					</Box>

					<Box sx={{ mt: 1 }}>
						<Typography level="body-sm" sx={{ mb: 0.5 }}>Ultima campagna</Typography>
						<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
							<Chip color="primary" variant="soft">{item?.lastCampaign || '-'}</Chip>
							<Chip color="primary" variant="soft">{formatDate(item?.updated_at)}</Chip>
						</Box>
					</Box>

					<Box sx={{ mt: 1 }}>
						<Typography level="body-sm" sx={{ mb: 0.5 }}>Fonte</Typography>
						<Chip color="primary" variant="soft">{item?.source || '-'}</Chip>
					</Box>
				</Box>
			</Box>

			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'flex-end',
					gap: 2,
					minWidth: 120
				}}
			>
				<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
					<Typography level="body-sm" sx={{ textAlign: 'right' }}>Privacy</Typography>
					<Tag color="success" label={`${formatDate(item?.registered_at)} - ${formatDate(item?.assigned_at)}`} dot />
				</Box>
				<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
					<Typography level="body-sm" sx={{ textAlign: 'right' }}>Black List</Typography>
					<Tag color="success" label={item?.blacklist ? 'Yes' : 'No'} dot />
				</Box>
				<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
					<Typography level="body-sm" sx={{ textAlign: 'right' }}>RPO</Typography>
					<Tag color="success" label={item?.rpo ? 'Yes' : 'No'} dot />
				</Box>
			</Box>
		</Box>
	)
}

export default InfoHeaderAudianceLead